/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';

export interface IAdressErrorTitle {
    title: string;
}

/**
 * Address error title.
 * @param props - Configuration of the functional component.
 * @returns React functional component.
 */
export const AddressErrorTitleFunctionComponent: React.FC<IAdressErrorTitle> = (props: IAdressErrorTitle) => {
    const { title } = props;

    return <p className='msc-address-form__error-title'>{title}</p>;
};

export default AddressErrorTitleFunctionComponent;
